document.addEventListener("DOMContentLoaded", () => {
  const host = location.host;
  const isExternalLink = h =>
    !/^(\/|#|mailto:|tel:|javascript:)/i.test(h) && !h.includes(host);

  document.querySelectorAll("a[href]").forEach(a => {
    const h = a.getAttribute("href");
    if (!h || !isExternalLink(h)) return;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
  });
});
